/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".shell[_ngcontent-%COMP%]{display:grid;grid-template-areas:\"header\" \"content\" \"footer\";grid-template-rows:auto 1fr auto;height:100vh}.shell[_ngcontent-%COMP%]   header[_ngcontent-%COMP%]{grid-area:header}.shell[_ngcontent-%COMP%]   main[_ngcontent-%COMP%]{grid-area:content;background:linear-gradient(180deg,rgba(254,253,253,0) 0,rgba(145,187,224,.1) 100%)}.shell[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]{grid-area:footer}"];
export { styles as styles };
